import {IState, ACTION_VERBS} from './Types';

import {parser} from './Parser';

/**
 *
 */
export const initialState: IState = {
  errors: [],
  banks: [],
  entities: [],
  profile: null,
  notifications: null,
  uiConfiguration: null,
  isOutdated: null,
  goToMessages: false,
  isLocalizationActive: false,
  remoteMessageError: null,
  sourceBanks: [],
};

/**
 *
 * @param state
 * @param action
 * @returns
 */
export const reducer = (state: IState, action: any) => {
  const {
    SIGN_IN,
    SIGN_OUT,
    CLEAR_ERRORS,
    ENTITIES,
    BALANCE_LIST,
    NOTIFICATION_LIST,
    SET_AUTHENTICATED,
    GET_TYC,
    BALANCE_SHEET,
    DOCUMENT_LIST,
    HISTORY,
    SEMAPHORE_ITEMS,
    DEBTOR_LIST,
    RECEIVABLE_LIST,
    IS_OUTDATED,
    MARK_NOTIFICATIONS_READ,
    ADD_NOTIFICATION,
    GO_TO_MESSAGES,
    GET_SALESMAN_CLIENTS,
    BALANCE_SHEET_SALESMAN,
    GET_SALESMAN_PRODUCTS,
    SET_SALESMAN_PRODUCT_TO_ADD,
    UPDATE_SALESMAN_NEW_ORDER,
    UPDATE_ORDER_ITEM_CANDIDATE_SHOPPING_CART,
    SEND_SALESMAN_NEW_ORDER,
    SET_SALESMAN_CLIENT,
    SET_LOCALIZATION_ACTIVE,
    SET_REMOTE_MESSAGE_ERROR,
  } = ACTION_VERBS;
  const cleaning = {...state, errors: []};

  switch (action.type) {
    case CLEAR_ERRORS:
      return {
        ...cleaning,
      };
    case SIGN_OUT:
      return {
        errors: [],
      } as IState;
    case SIGN_IN:
      return {
        ...cleaning,
        ...parser.sigin(action.payload),
      } as IState;
    case SET_AUTHENTICATED:
      return {
        ...parser.setAuthenticated(state),
      } as IState;
    case ENTITIES:
      return {
        ...parser.entities(state, action.payload),
      } as IState;
    case GET_TYC:
      return {
        ...parser.tyc(state, action.payload),
      } as IState;
    case BALANCE_LIST:
      return {
        ...parser.balanceList(state, action.payload),
      } as IState;
    case HISTORY:
      return {
        ...parser.history(state, action.payload),
      } as IState;
    case BALANCE_SHEET_SALESMAN:
      return {
        ...parser.balanceSheetSalesman(state, action.payload),
      } as IState;
    case BALANCE_SHEET:
      return {
        ...parser.balanceSheet(state, action.payload),
      } as IState;
    case NOTIFICATION_LIST:
      return {
        ...parser.notificatioList(state, action.payload),
      } as IState;
    case DOCUMENT_LIST:
      return {
        ...parser.documentList(state, action.payload),
      } as IState;
    case SEMAPHORE_ITEMS:
      return {
        ...parser.semaphoreItems(state, action.payload),
      } as IState;
    case DEBTOR_LIST:
      return {
        ...parser.debtorList(state, action.payload),
      } as IState;
    case RECEIVABLE_LIST:
      return {
        ...parser.receivableList(state, action.payload),
      } as IState;
    case IS_OUTDATED:
      return {
        ...parser.isOutdated(state, action.payload),
      } as IState;
    case MARK_NOTIFICATIONS_READ:
      return {
        ...parser.markNotificationsRead(state),
      } as IState;
    case ADD_NOTIFICATION:
      return {
        ...parser.addNotification(state, action.payload),
      } as IState;
    case GO_TO_MESSAGES:
      return {
        ...parser.setGoToMessage(state, action.payload),
      } as IState;
    case GET_SALESMAN_CLIENTS:
      return {
        ...parser.salesmanClientList(state, action.payload),
      } as IState;
    case GET_SALESMAN_PRODUCTS:
      return {
        ...parser.salesmanProductList(state, action.payload),
      } as IState;
    case SET_SALESMAN_PRODUCT_TO_ADD:
      return {
        ...parser.setSalesmanProductToAdd(state, action.payload),
      } as IState;
    case UPDATE_SALESMAN_NEW_ORDER:
      return {
        ...parser.updateSalesmanNewOrder(state, action.payload),
      } as IState;

    case UPDATE_ORDER_ITEM_CANDIDATE_SHOPPING_CART:
      return {
        ...parser.updateCandidateToShoppingCart(state, action.payload),
      } as IState;
    case SEND_SALESMAN_NEW_ORDER:
      return {
        ...parser.sendSalesmanNewOrder(state),
      } as IState;
    case SET_SALESMAN_CLIENT:
      return {
        ...parser.setSalesmanClient(state, action.payload),
      } as IState;
    case SET_LOCALIZATION_ACTIVE:
      return {
        ...parser.setState('isLocalizationActive', state, action.payload),
      } as IState;
    case SET_LOCALIZATION_ACTIVE:
      return {
        ...parser.setState('isLocalizationActive', state, action.payload),
      } as IState;
    case SET_REMOTE_MESSAGE_ERROR:
      return {
        ...parser.setState('remoteMessageError', state, action.payload),
      } as IState;
    default:
      return state;
  }
};
